import { Menu } from "@mui/material";
import React from "react";
export const HoverMenu = React.forwardRef(({ PaperProps, style, ...props }, ref) => (React.createElement(Menu, { ...props, ref: ref, style: { pointerEvents: "none", ...style }, PaperProps: {
        ...PaperProps,
        style: { pointerEvents: "auto", ...PaperProps?.style },
    } })));
HoverMenu.displayName = "HoverMenu";
//# sourceMappingURL=hover-menu.js.map